import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuthentication } from '../../auth';
import { dateRanges } from '../../components/Input';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/Tabs';
import { isSuperAdmin } from '../../util/auth';
import { OrgDashboardContent } from '../org-dashboard/OrgDashboardContent';
import { OrgDashboardToolbar } from '../org-dashboard/OrgDashboardToolbar';
import { ClinicianDashboardContent } from './ClinicianDashboardContent';
import { ClinicianDashboardToolbar } from './ClinicianDashboardToolbar';

enum ClinicianDashboardTab {
  MyActivity = 'activity',
  Organization = 'organization'
}

export function ClinicianDashboard() {
  const currentUser = useAuthentication();
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab =
    searchParams.get('tab') ??
    (isSuperAdmin(currentUser) ? ClinicianDashboardTab.Organization : ClinicianDashboardTab.MyActivity);

  const [activityTypeIds, setActivityTypeIds] = useState<string[]>([]);
  const [dateRange, setDateRange] = useState<[Date, Date] | null>(dateRanges.last30days.value);

  return (
    <Tabs value={activeTab} onValueChange={(tab) => setSearchParams({ tab })} className="flex h-full flex-col">
      <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
        <TabsList className="grid w-full grid-cols-2 md:w-[400px] md:min-w-[400px]">
          <TabsTrigger value={ClinicianDashboardTab.MyActivity}>My Activity</TabsTrigger>
          <TabsTrigger value={ClinicianDashboardTab.Organization}>My Organization</TabsTrigger>
        </TabsList>

        {activeTab === ClinicianDashboardTab.MyActivity && (
          <ClinicianDashboardToolbar dateRange={dateRange} onDateRangeChange={setDateRange} />
        )}

        {activeTab === ClinicianDashboardTab.Organization && (
          <OrgDashboardToolbar
            activityTypeIds={activityTypeIds}
            onActivityTypeIdsChange={setActivityTypeIds}
            dateRange={dateRange}
            onDateRangeChange={setDateRange}
          />
        )}
      </div>

      <TabsContent value={ClinicianDashboardTab.MyActivity} className="flex w-full flex-col justify-center gap-4 py-5">
        <ClinicianDashboardContent dateRange={dateRange} />
      </TabsContent>

      <TabsContent value={ClinicianDashboardTab.Organization} className="flex w-full flex-col justify-center gap-4">
        <OrgDashboardContent activityTypeIds={activityTypeIds} dateRange={dateRange} />
      </TabsContent>
    </Tabs>
  );
}
